<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableLogDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            v-hasPermission="['logs:logMonitor:delete']"
            size="small"
            @click="LogDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除实例模式框 -->
    <Modal v-model="LogDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ logInstanceId }}
          {{ $t("alarms.common.allWarningRules") }}？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeLog()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableLogVue = {};
export default {
  name: "TableLog",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      LogDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      logInstanceId: "",
      stateType: [
        "pending",
        "running",
        "stopping",
        "stopped",
        "shutting down",
        "terminated"
      ],
      columns: [
        {
          title: this.$t("alarms.log.application.name"),
          key: "name"
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.log.application.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("alarms.log.application.ip"),
          key: "privateIp"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state"
        },
        {
          title: this.$t("alarms.log.application.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableLogDate: []
    };
  },
  beforeCreate: function() {
    tableLogVue = this;
  },
  mounted: function() {
    tableLogVue.getLogData();
  },
  methods: {
    showAll: function() {
      tableLogVue.getLogData();
    },
    // 分页显示数据
    /****************************************************/
    getLogData: function() {
      // 获取LogMonitorSearch里面的搜索内容
      eventBus.$on("instanceIdSearchName", function(val) {
        tableLogVue.instanceIdSearchName = val;
      });
      // 获取LogMonitorSearch里面的搜索内容
      eventBus.$on("regionName", function(val) {
        tableLogVue.region = val;
      });
      // 获取LogMonitorSearch里面的搜索内容
      eventBus.$on("companyId", function(val) {
        tableLogVue.companyId = val;
      });
      //账户列表分页
      this.$api.instance
        .pageInstance({
          instanceId: tableLogVue.instanceIdSearchName,
          companyId: tableLogVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 13,
          region: tableLogVue.region
        })
        .then(res => {
          this.tableLogDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
          // 状态
          for (var i = 0; i < this.tableLogDate.length; i++) {
            this.tableLogDate[i].state = this.stateType[
              this.tableLogDate[i].state
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableLogVue.getLogData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableLogVue.getLogData();
    },
    // 销毁instanceIdSearchName
    beforeDestroy: function() {
      eventBus.$off("instanceIdSearchName");
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.logInstanceId = this.tableLogDate[index].instanceId;
    },
    removeLog: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.instance
        .deleteInstance("id", this.tableLogDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableLogVue.getLogData();
            this.isDisable = false;
            this.modal_loading = false;
            this.LogDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/log/TableLog.vue